<template>
<BaseModal
    :id="'unassigned-work-modal'"
    :title="title"
    :size="'lg'"
    :message="message"
    >
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb_modal"/>
    </template>

    <template v-slot:content >
        <div class="discharges-header mt-3">
            <div  class="d-flex form-discharges shadow p-3 mt-3 mb-3 bg-body rounded">
                <div class="p-0  form-discharges__minutes" style="flex: 2;"> 
                    <div class="formdynamic__item__field">
                        <!-- <b v-html="`Amount`"/> -->
                        <b style='color:red;'>*</b>
                        <input  
                            min="1"
                            max="30"
                            placeholder="amount"
                            type="number" 
                            v-model="unassigned_work_item.amount"
                        />
                    </div>
                </div>
                <div class="p-0  form-discharges__bed" style="flex: 5;">
                    <div class="formdynamic__item__field" id="multiselect__schedule">
                        <b style='color:red;'>*</b>
                        <select placeholder="Enter the description" required="required" class="custom-select" style="max-width: 100%;" v-model="unassigned_work_item.unassigned_work_header_id">
                            <option value="" v-html="`Select an option`" />
                            <option :value="unassigned_work_header.id" v-for="(unassigned_work_header, i) in unassigned_work_headers" :key="i" v-html="unassigned_work_header.description" />
                        </select>
                    </div>
                </div>
                <div class="p-0  form-discharges__minutes" style="flex: 5;">
                    <div class="formdynamic__item__field">
                        <b style='color:red;'>*</b>
                        <input  
                            placeholder="minutes"
                            type="number" 
                            v-model="unassigned_work_item.minutes"
                        />
                    </div>
                </div>
                <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top: 0px;">
                    <button
                        @click="addUnassignedWorkItem()"
                        class="modal__buttons__item"
                        v-html="`Add`"
                        style="width:5rem;"
                        type="button"
                        :disabled="loading_creation"
                        :class="{'disabled button__disabled' : loading_creation}"
                    />
                </div>
            </div>
        </div>
        <div class="tab-content mt-5" v-if="unassigned_work_items.length && hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <div class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head">
                            <table class="table">
                                <thead style="background-color: #ffff">
                                    <tr>
                                    <th v-html="'#'"/>
                                    <th
                                        style="font-weight: normal !important; width: 25%;"
                                        class="header-item-manual"
                                        v-for="(item, i) in unassigned_work_table_headers"
                                        :key="i"
                                        scope="col"
                                        v-html="item.text"
                                    />
                                    <th v-html="'Actions'"/>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in unassigned_work_items" :key="i">
                                        <td v-html="`${i + 1}`" />
                                        <td style="width: 25%;">
                                            <div class="p-0 form-discharges__minutes">
                                                <div class="formdynamic__item__field">
                                                    <input placeholder="minutes" type="number" v-model="item.minutes" :disabled="!item.editing">
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 25%;">
                                            <div id="description" class="formdynamic__item__field mt-2">
                                                <select placeholder="Enter the description" required="required" class="custom-select" style="max-width: 100%;" :disabled="!item.editing" v-model="item.unassigned_work_header_id">
                                                    <option :value="unassigned_work_header.id" v-for="(unassigned_work_header, i) in unassigned_work_headers" :key="i" v-html="unassigned_work_header.description" />
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            {{item.created_at ? moment(item.created_at).format("MM/D/YYYY hh:mm:ss A") : item.created_at}}
                                        </td>
                                        <td>
                                            <div class="modal__buttons" style="margin-top: 0.4rem;" v-if="is_loading !== i">
                                                <button type="button" class="modal__buttons__item" style="width: 3rem;" @click="item.editing ? update(item, i) : item.editing = true">{{item.editing ? 'Save' : 'Edit'}}</button>
                                                <button type="button" class="modal__buttons__item cancel" style="width: 4rem;" @click="remove(item, i)">Remove</button>
                                            </div>
                                            <div v-else>
                                                <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form @submit.prevent="closeModal()">
            <CentralLiteButtons save_text="Done" style="margin-top: -.2rem;"/>
        </form>
        </template>
    </BaseModal>
</template>

<script>

import Resources          from    './resources'
import Breadcrumb         from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal          from    '@/components/BaseModal'
import CentralLiteButtons from    '@/components/CentralLiteButtons'
import moment from 'moment';

export default {
name: "FormModalUnassignedWork",
props: [
    "title",
    "parent_id",
    "daily_assignment",
    "breadcrumb_modal",
    "unassigned_work_items",
    "unassigned_work_headers"
],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return {
            message: "You can edit the unassigned work items for this assignment here. To add new unassigned work items, specify the amount of unassigned work you want to add (up to a maximum of 30). Enter the required number of minutes, and choose the appropriate work description.",
            unassigned_work_table_headers: Resources.unassigned_work_table_headers,
            rest_api: 'unassigned_work_items',
            log_productivity_api: 'log_productivity',
            is_loading: -1,
            unassigned_work_item: {
                amount: 1,
                unassigned_work_header_id: '',
                minutes: ''
            },
            loading_creation: false,
            moment
        }
    },
    methods: 
    {
        async update(item, index)
        {
            const obj = {
                minutes: item.minutes,
                unassigned_work_header_id: item.unassigned_work_header_id
            }

            this.is_loading = index
            const res = await this.put(`${this.log_productivity_api}/unassigned_work_items/${item.id}`, obj)
            this.is_loading = -1

            if(res.status)
            {
                this.notyfMesg('Changes were saved')
                item.editing = false
            }
            else
            {
                this.error_handling(res)
            }
        },

        async remove(item, index)
        {
            this.is_loading = index
            const res = await this.delete(`${this.log_productivity_api}/unassigned_work_items/${item.id}`,)
            this.is_loading = -1

            if(res.status)
            {
                this.notyfMesg('Item was removed')
                this.unassigned_work_items.splice(index, 1)
            }
            else
            {
                this.error_handling(res)
            }
        },

        closeModal()
        {
            window.$(`#unassigned-work-modal`).modal('hide');
            this.$emit('refreshData', {})
        },

        async addUnassignedWorkItem()
        {
            if(!this.unassigned_work_item.unassigned_work_header_id)
            {
                this.notyfMesg('Select a work', 'error')
                return;
            }
            if(!this.unassigned_work_item.minutes)
            {
                this.notyfMesg('Enter minutes', 'error')
                return;
            }
            this.loading_creation = true


            const http_obj = {
                log_productivity_id: this.parent_id,
                ...this.unassigned_work_item
            }

            const res = await this.post(`${this.log_productivity_api}/unassigned_work_items`, http_obj)

            this.loading_creation = false

            if(res.status)
            {
                res.data.forEach(item => {
                    this.unassigned_work_items.push(item)
                });
                this.notyfMesg('Success')
                this.unassigned_work_item.unassigned_work_header_id = ''
                this.unassigned_work_item.minutes = ''
                this.unassigned_work_item.amount = 1
            }
            else
            {
                this.error_handling(res)
            }
        }

    },

    computed: {
        array_options_table()
        {
            const sum = this.unassigned_work_items.reduce((acc, item) => {
                return acc + this.stringToNumber(item.minutes)
            }, 0)

            return [{text: 'Total minutes', value: sum, type: 'number'}]
        }
      },
};
</script>